export default __webpack_public_path__ + "static/TauvagaSiolo-c471c37c3bc125dbf9eb308fc77d7bf5.png";